<template>
  <nuttrema-layout-form-standard :edit="edit" :theme="theme" :saveError="TeamMemberDetails.saveError">
    <template slot="center">
      <el-form
         label-width="25%"
        :rules="rules"
        :ref="formRef"
        :model="formData"
        :label-position="labelPosition">

        <section>
          <h4 class="section-title">{{ $t('label.basic') }}</h4>
          <div class="section-items">
            <el-form-item :label="$t('label.title')" prop="personal_title">
              <el-col class="el-col--min-10em" :span="4" :xs="12">
                <el-input :value="_get(TeamMemberDetails, 'data.personal_title')" :disabled="!edit"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.first_name')" prop="first_name">
              <el-col class="el-col--min-16em" :span="12" :xs="24">
                <el-input :value="_get(TeamMemberDetails, 'data.first_name')" :disabled="!edit"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.last_name')" prop="last_name">
              <el-col class="el-col--min-16em" :span="12" :xs="24">
                <el-input :value="_get(TeamMemberDetails, 'data.last_name')" :disabled="!edit"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.primary_role')" prop="primary_role">
              <el-col class="el-col--min-16em" :span="12" :xs="24">
                <el-input :value="_get(formData, 'primary_role.name')" :disabled="!edit"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.gender')" prop="gender">
              <el-col class="el-col--min-15em" :span="6">
                <el-select :value="_get(TeamMemberDetails, 'data.gender')" class="w-100" :disabled="!edit">
                  <el-option :label="$t('label.male')" value="male"></el-option>
                  <el-option :label="$t('label.female')" value="female"></el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <el-form-item :label="$t('label.occupation')" prop="occupation">
              <el-col class="el-col--min-16em" :span="12" :xs="24">
                <el-input :value="_get(TeamMemberDetails, 'data.occupation')" :disabled="!edit"></el-input>
              </el-col>
            </el-form-item>
          </div>
        </section>

        <section>
          <h4 class="section-title">{{ $t('label.contact') }}</h4>
            <div class="section-items">
            <el-form-item :label="$t('label.email')" prop="email">
              <el-col  class="el-col--min-16em" :span="12" :xs="24">
                <el-input :value="_get(TeamMemberDetails, 'data.email')" :disabled="true"></el-input>
              </el-col>
            </el-form-item>
          </div>
        </section>

        <section>
          <h4 class="section-title">{{ $t('label.regional_settings') }}</h4>
          <div class="section-items">
            <el-form-item :label="$t('label.preffered_language')">
              <el-col  class="el-col--min-17em" :span="6">
                <el-select :value="_get(TeamMemberDetails, 'data.language_id')" class="w-100" :disabled="!edit">
                  <el-option v-for="language in _get(RegionalAndLanguageAll, 'data.Languages', [])"
                    :label="language.native_name"
                    :value="language.id"
                    :key="language.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>


            <el-form-item :label="$t('label.measurement_system')">
              <el-col class="el-col--min-17em" :span="6">
                <el-select :value="_get(TeamMemberDetails, 'data.measurement_system_id')" class="w-100" :disabled="!edit">
                  <el-option v-for="measurementSystem in _get(RegionalAndLanguageAll, 'data.MeasurementSystems', [])"
                    :label="measurementSystem.name"
                    :value="measurementSystem.id"
                    :key="measurementSystem.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <!-- <el-form-item :label="$t('label.time_zone')">
              <el-col class="el-col--min-17em" :span="8">
                <el-cascader
                   class="w-100"
                  :filterable="true"
                  :disabled="!edit"
                  :clearable="edit"
                  :value="_get(TeamMemberDetails, 'data.time_zone_id')"
                  :options="_get(RegionalAndLanguageAll, 'data.TimeZones', [])"
                  :props="{ label: 'title', value: 'id', children: 'Zones' }"
                  :show-all-levels="true">
                </el-cascader>
              </el-col>
            </el-form-item> -->
          </div>
        </section>

        <section>
          <h4 class="section-title">{{ $t('label.address') }}</h4>
          <div class="section-items">
            <el-form-item :label="$t('label.city_and_country')" prop="city">
              <el-col :span="10">
                <el-input :value="_get(TeamMemberDetails, 'data.PersonData.address_city.value')" :placeholder="$t('label.city')" :disabled="!edit"></el-input>
              </el-col>
              <el-col :span="10" :offset="1">
                <el-cascader
                   class="w-100"
                  :disabled="!edit"
                  :clearable="edit"
                  :filterable="true"
                  :value="_get(TeamMemberDetails, 'data.region_id')"
                  :options="_get(RegionalAndLanguageAll, 'data.Regions', [])"
                  :props="{ label: 'title', value: 'id', children: 'SubRegions' }"
                  :show-all-levels="false">
                </el-cascader>
              </el-col>
            </el-form-item>
          </div>
        </section>


      </el-form>
    </template>
  </nuttrema-layout-form-standard>
</template>

<script>
import { get, find } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

export default {
  name: 'form-team-member-main-details',
  mixins: [
    FormStandardBehavior,
  ],
  props: {
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    theme: {
      type: String,
      required: false,
      default: null,
    },
    labelPosition: {
      type: String,
      required: false,
      default: 'right',
    },
    TeamMemberDetails: {
      type: Object,
      required: false,
    },
    RegionalAndLanguageAll: {
      required: true,
      default: null,
    },
  },
  components: {
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      formData: {
        primary_role: null,
      },
      rules: {},
    };
  },
  methods: {
    setFormData() {
      const roles = get(this.TeamMemberDetails, 'data.Roles', []);
      this.formData.primary_role = find(roles, role => get(role, 'PersonRole.primary_role'));
    },
  },
  created() {
    this.stateData = this.TeamMemberDetails;
    this.formRef = 'form-team-member-main-details';
    this.setFormData();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/my-team/main-details/form-team-member-main-details.vue